export default {
  phases: {
    phase1: {
      title: '第一阶段：基础建设',
      milestones: {
        protocol: {
          title: '核心协议开发',
          description: '完成Titron核心隐私保护协议的开发',
          date: '2024年1月'
        },
        testnet: {
          title: '测试网络上线',
          description: '启动Titron测试网络，支持开发者测试',
          date: '2024年2月'
        },
        ecosystem: {
          title: '开发者生态',
          description: '建立完整的开发者生态系统',
          date: '2025年5月'
        },
        dapps: {
          title: '首批DApp',
          description: '推出首批基于Titron的DApp应用',
          date: '2025年12月'
        }
      }
    }
  },
  status: {
    completed: '已完成',
    'in-progress': '进行中',
    upcoming: '即将开始',
    future: '规划中'
  }
};
